/* src/routes/blog/boxstarter-hello-world.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import Prism from "../../../_components/PrismJS.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";

function create_default_slot_11(ctx) {
	let t;

	return {
		c() {
			t = text("Setting up a new machine is always a bit of a pain. Wouldn't it be nice if\n    your machine could just get the software you wanted and install it for you.");
		},
		l(nodes) {
			t = claim_text(nodes, "Setting up a new machine is always a bit of a pain. Wouldn't it be nice if\n    your machine could just get the software you wanted and install it for you.");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (25:4) <LinkExternal href="http://boxstarter.org/">
function create_default_slot_10(ctx) {
	let t;

	return {
		c() {
			t = text("BoxStarter.org");
		},
		l(nodes) {
			t = claim_text(nodes, "BoxStarter.org");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (24:2) <PostSection title="Welcome BoxStarter">
function create_default_slot_9(ctx) {
	let linkexternal;
	let t;
	let prism;
	let current;

	linkexternal = new LinkExternal({
			props: {
				href: "http://boxstarter.org/",
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	prism = new Prism({
			props: {
				language: "powershell",
				code: `
START
http://boxstarter.org/package/nr/url?URL_TO_YOUR_BOXSTARTER_SCRIPT.ps1
`
			}
		});

	return {
		c() {
			create_component(linkexternal.$$.fragment);
			t = text("\n    can install all of your software out with a single command.\n    ");
			create_component(prism.$$.fragment);
		},
		l(nodes) {
			claim_component(linkexternal.$$.fragment, nodes);
			t = claim_text(nodes, "\n    can install all of your software out with a single command.\n    ");
			claim_component(prism.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(linkexternal, target, anchor);
			insert(target, t, anchor);
			mount_component(prism, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal_changes.$$scope = { dirty, ctx };
			}

			linkexternal.$set(linkexternal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal.$$.fragment, local);
			transition_in(prism.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal.$$.fragment, local);
			transition_out(prism.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(linkexternal, detaching);
			if (detaching) detach(t);
			destroy_component(prism, detaching);
		}
	};
}

// (40:4) <LinkExternal       href="https://raw.githubusercontent.com/Gaweph/Boxstarter-scripts/master/Developer-Machine.ps1">
function create_default_slot_8(ctx) {
	let t;

	return {
		c() {
			t = text("GitHub Repository");
		},
		l(nodes) {
			t = claim_text(nodes, "GitHub Repository");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (36:2) <PostSection title="My Script">
function create_default_slot_7(ctx) {
	let t0;
	let strong;
	let t1;
	let t2;
	let linkexternal;
	let t3;
	let prism;
	let current;

	linkexternal = new LinkExternal({
			props: {
				href: "https://raw.githubusercontent.com/Gaweph/Boxstarter-scripts/master/Developer-Machine.ps1",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	prism = new Prism({
			props: {
				language: "powershell",
				code: `
# Boxstarter options
$Boxstarter.RebootOk=$true # Allow reboots?
$Boxstarter.NoPassword=$false # Is this a machine with no login password?
$Boxstarter.AutoLogin=$true # Save my password securely and auto-login after a reboot
# Basic setup
Update-ExecutionPolicy Unrestricted
Set-ExplorerOptions -showHidenFilesFoldersDrives -showProtectedOSFiles -showFileExtensions
#Enable-RemoteDesktop
Disable-InternetExplorerESC
#Disable-UAC
#Set-TaskbarSmall
 
# disable defrag because I have an SSD 
Get-ScheduledTask -TaskName *defrag* | Disable-ScheduledTask 
# Install Visual Studio 2015
cinst visualstudio2015enterprise
if (Test-PendingReboot) { Invoke-Reboot }
#Other dev tools
cinst visualstudiocode -y
cinst nodejs.install -y
choco install unity -y
#Browsers
cinst googlechrome -y
cinst firefox -y
#Other tools
cinst notepadplusplus -y
cinst 7zip.install -y
cinst adobereader -y
cinst skype -y
cinst dropbox -y
cinst virtualbox -y
choco install jdk8 -y
cinst putty.install -y
cinst spotify -y
cinst vlc -y
choco install steam -y
# VS extensions
Install-ChocolateyVsixPackage ProPowerTools https://visualstudiogallery.msdn.microsoft.com/d0d33361-18e2-46c0-8ff2-4adea1e34fef/file/29666/12/ProPowerTools.vsix
Install-ChocolateyVsixPackage vstu2015 https://visualstudiogallery.msdn.microsoft.com/8d26236e-4a64-4d64-8486-7df95156aba9/file/142077/10/vstu2015.msi
# Node modules (Global)
npm install -g gulp
npm install -g bower
npm install -g typings
npm install -g hexo-cli
npm install -g typescript
if (Test-PendingReboot) { Invoke-Reboot }
#cinst Microsoft-Hyper-V-All -source windowsFeatures
cinst IIS-WebServerRole -source windowsfeatures
cinst IIS-HttpCompressionDynamic -source windowsfeatures
cinst IIS-ManagementScriptingTools -source windowsfeatures
cinst IIS-WindowsAuthentication -source windowsfeatures
Install-ChocolateyPinnedTaskBarItem "$($Boxstarter.programFiles86)\Google\Chrome\Application\chrome.exe"
Install-ChocolateyPinnedTaskBarItem "$($Boxstarter.programFiles86)\Microsoft Visual Studio 14.0\Common7\IDE\devenv.exe"
# Update Windows and reboot if necessary
Install-WindowsUpdate -AcceptEula -GetUpdatesFromMS
if (Test-PendingReboot) { Invoke-Reboot }
      `
			}
		});

	return {
		c() {
			t0 = text("My current\n    ");
			strong = element("strong");
			t1 = text("Home Development Script");
			t2 = text("\n    can be found at my\n    ");
			create_component(linkexternal.$$.fragment);
			t3 = text("\n    Here it is at the time of writing this post:\n    ");
			create_component(prism.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "My current\n    ");
			strong = claim_element(nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t1 = claim_text(strong_nodes, "Home Development Script");
			strong_nodes.forEach(detach);
			t2 = claim_text(nodes, "\n    can be found at my\n    ");
			claim_component(linkexternal.$$.fragment, nodes);
			t3 = claim_text(nodes, "\n    Here it is at the time of writing this post:\n    ");
			claim_component(prism.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, strong, anchor);
			append(strong, t1);
			insert(target, t2, anchor);
			mount_component(linkexternal, target, anchor);
			insert(target, t3, anchor);
			mount_component(prism, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal_changes.$$scope = { dirty, ctx };
			}

			linkexternal.$set(linkexternal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal.$$.fragment, local);
			transition_in(prism.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal.$$.fragment, local);
			transition_out(prism.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(strong);
			if (detaching) detach(t2);
			destroy_component(linkexternal, detaching);
			if (detaching) detach(t3);
			destroy_component(prism, detaching);
		}
	};
}

// (109:4) <LinkExternal href="https://chocolatey.org/packages">
function create_default_slot_6(ctx) {
	let t;

	return {
		c() {
			t = text("Chocolatey Packages");
		},
		l(nodes) {
			t = claim_text(nodes, "Chocolatey Packages");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (107:2) <Callout>
function create_default_slot_5(ctx) {
	let t0;
	let linkexternal;
	let t1;
	let current;

	linkexternal = new LinkExternal({
			props: {
				href: "https://chocolatey.org/packages",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("Boxstarter is able to use\n    ");
			create_component(linkexternal.$$.fragment);
			t1 = text("\n    which means it has access to many many pieces of software.");
		},
		l(nodes) {
			t0 = claim_text(nodes, "Boxstarter is able to use\n    ");
			claim_component(linkexternal.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n    which means it has access to many many pieces of software.");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(linkexternal, target, anchor);
			insert(target, t1, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal_changes.$$scope = { dirty, ctx };
			}

			linkexternal.$set(linkexternal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(linkexternal, detaching);
			if (detaching) detach(t1);
		}
	};
}

// (116:4) <Callout>
function create_default_slot_4(ctx) {
	let t;

	return {
		c() {
			t = text("Alternatively you can now use a Package Manager in Windows.");
		},
		l(nodes) {
			t = claim_text(nodes, "Alternatively you can now use a Package Manager in Windows.");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (120:4) <LinkExternal href="https://chocolatey.org/">
function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("Chocolatey");
		},
		l(nodes) {
			t = claim_text(nodes, "Chocolatey");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (122:4) <LinkExternal href="https://chocolatey.org/packages">
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("Packages");
		},
		l(nodes) {
			t = claim_text(nodes, "Packages");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (115:2) <PostSection title="Other Windows 10 Options">
function create_default_slot_1(ctx) {
	let callout;
	let t0;
	let linkexternal0;
	let t1;
	let linkexternal1;
	let current;

	callout = new Callout({
			props: {
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	linkexternal0 = new LinkExternal({
			props: {
				href: "https://chocolatey.org/",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "https://chocolatey.org/packages",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(callout.$$.fragment);
			t0 = text("\n    Windows 10 now includes a Package Manager. Check out my personal favourite\n    ");
			create_component(linkexternal0.$$.fragment);
			t1 = text("\n    which includes many many\n    ");
			create_component(linkexternal1.$$.fragment);
		},
		l(nodes) {
			claim_component(callout.$$.fragment, nodes);
			t0 = claim_text(nodes, "\n    Windows 10 now includes a Package Manager. Check out my personal favourite\n    ");
			claim_component(linkexternal0.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n    which includes many many\n    ");
			claim_component(linkexternal1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(callout, target, anchor);
			insert(target, t0, anchor);
			mount_component(linkexternal0, target, anchor);
			insert(target, t1, anchor);
			mount_component(linkexternal1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const callout_changes = {};

			if (dirty & /*$$scope*/ 4) {
				callout_changes.$$scope = { dirty, ctx };
			}

			callout.$set(callout_changes);
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(callout.$$.fragment, local);
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(callout.$$.fragment, local);
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(callout, detaching);
			if (detaching) detach(t0);
			destroy_component(linkexternal0, detaching);
			if (detaching) detach(t1);
			destroy_component(linkexternal1, detaching);
		}
	};
}

// (18:0) <PostContents>
function create_default_slot(ctx) {
	let postsection0;
	let t0;
	let postsection1;
	let t1;
	let postsection2;
	let t2;
	let callout;
	let t3;
	let postsection3;
	let current;

	postsection0 = new PostSection({
			props: {
				title: "Whats the problem",
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	postsection1 = new PostSection({
			props: {
				title: "Welcome BoxStarter",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	postsection2 = new PostSection({
			props: {
				title: "My Script",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	callout = new Callout({
			props: {
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	postsection3 = new PostSection({
			props: {
				title: "Other Windows 10 Options",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postsection0.$$.fragment);
			t0 = space();
			create_component(postsection1.$$.fragment);
			t1 = space();
			create_component(postsection2.$$.fragment);
			t2 = space();
			create_component(callout.$$.fragment);
			t3 = space();
			create_component(postsection3.$$.fragment);
		},
		l(nodes) {
			claim_component(postsection0.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(postsection1.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(postsection2.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(callout.$$.fragment, nodes);
			t3 = claim_space(nodes);
			claim_component(postsection3.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postsection0, target, anchor);
			insert(target, t0, anchor);
			mount_component(postsection1, target, anchor);
			insert(target, t1, anchor);
			mount_component(postsection2, target, anchor);
			insert(target, t2, anchor);
			mount_component(callout, target, anchor);
			insert(target, t3, anchor);
			mount_component(postsection3, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection0_changes.$$scope = { dirty, ctx };
			}

			postsection0.$set(postsection0_changes);
			const postsection1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection1_changes.$$scope = { dirty, ctx };
			}

			postsection1.$set(postsection1_changes);
			const postsection2_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection2_changes.$$scope = { dirty, ctx };
			}

			postsection2.$set(postsection2_changes);
			const callout_changes = {};

			if (dirty & /*$$scope*/ 4) {
				callout_changes.$$scope = { dirty, ctx };
			}

			callout.$set(callout_changes);
			const postsection3_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection3_changes.$$scope = { dirty, ctx };
			}

			postsection3.$set(postsection3_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postsection0.$$.fragment, local);
			transition_in(postsection1.$$.fragment, local);
			transition_in(postsection2.$$.fragment, local);
			transition_in(callout.$$.fragment, local);
			transition_in(postsection3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postsection0.$$.fragment, local);
			transition_out(postsection1.$$.fragment, local);
			transition_out(postsection2.$$.fragment, local);
			transition_out(callout.$$.fragment, local);
			transition_out(postsection3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postsection0, detaching);
			if (detaching) detach(t0);
			destroy_component(postsection1, detaching);
			if (detaching) detach(t1);
			destroy_component(postsection2, detaching);
			if (detaching) detach(t2);
			destroy_component(callout, detaching);
			if (detaching) detach(t3);
			destroy_component(postsection3, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "My Boxstarter Script";
const date = "2016-08-17 21:04:00";

function instance($$self) {
	const tags = ["software", "automation"];
	const projects = [];
	return [tags, projects];
}

class Boxstarter_hello_world extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Boxstarter_hello_world;
//# sourceMappingURL=boxstarter-hello-world.svelte.js.map
